import React, { useState } from 'react';
import { User, Palette, LogOut } from 'lucide-react';

import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../providers/ThemeProvider';
import ThemeModal from '../common/ThemeModal';
import './Topbar.css';

const BRAND_NAME = 'RochaSystem';
const appLogoUrl = '/Logo-Colorida-BxgVG3_4.png';

const Topbar = ({ onMenuClick }) => {
  const { logout, user } = useAuth();
  const { theme, isDark } = useTheme();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showThemeModal, setShowThemeModal] = useState(false);

  const handleLogout = () => {
    logout();
  };

  const getInitials = (name = '') => {
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const getThemeLabel = () => {
    if (theme === 'system') return 'Sistema';
    return isDark ? 'Escuro' : 'Claro';
  };

  const getThemeIcon = () => {
    if (theme === 'system') return '🖥️';
    return isDark ? '🌙' : '☀️';
  };

  return (
    <header className="topbar">
      <div className="topbar__left">
        <button className="topbar__menu-button" onClick={onMenuClick} aria-label="Abrir menu">
          ☰
        </button>
        <img
          src={appLogoUrl}
          alt={BRAND_NAME}
          className="topbar__logo"
          title={BRAND_NAME}
          width={200}
          height={40}
          decoding="async"
          fetchPriority="high"
        />
      </div>

      <div className="topbar__right">
        {/* Menu do Usuário */}
        {user && (
          <div className="topbar__user" style={{ position: 'relative' }}>
            <button
              className="topbar__avatar"
              onClick={() => setShowUserMenu(!showUserMenu)}
              aria-label="Abrir menu do usuário"
              title={user.name}
            >
              {getInitials(user.name)}
            </button>

            {showUserMenu && (
              <div className="topbar__user-menu">
                <div className="topbar__user-header">
                  <div className="topbar__avatar topbar__avatar--sm">{getInitials(user.name)}</div>
                  <div className="topbar__user-meta">
                    <div className="topbar__user-name">{user.name}</div>
                    <div className="topbar__user-email">{user.email}</div>
                  </div>
                </div>

                <button
                  className="topbar__user-item"
                  onClick={() => (window.location.href = '/profile')}
                >
                  <User size={16} />
                  Perfil
                </button>

                <button
                  className="topbar__user-theme-section"
                  onClick={() => {
                    setShowThemeModal(true);
                    setShowUserMenu(false);
                  }}
                >
                  <Palette size={16} />
                  <div className="topbar__user-theme-content">
                    <div className="topbar__user-theme-label">Tema</div>
                    <div className="topbar__user-theme-subtitle">
                      {getThemeIcon()} {getThemeLabel()}
                    </div>
                  </div>
                </button>

                <hr className="topbar__divider" />

                <button
                  className="topbar__user-item topbar__user-item--danger"
                  onClick={handleLogout}
                >
                  <LogOut size={16} />
                  Sair
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Overlay para fechar dropdown */}
      {showUserMenu && (
        <div
          className="topbar__dropdown-overlay"
          onClick={() => setShowUserMenu(false)}
        />
      )}

      {/* Modal de Tema */}
      <ThemeModal isOpen={showThemeModal} onClose={() => setShowThemeModal(false)} />
    </header>
  );
};

export default Topbar;
